
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community_guideline",
      function () {
        return require("private-next-pages/community_guideline/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community_guideline"])
      });
    }
  